import { dailySessionNotes } from '../../actions/constant';

const {
  DELETE_DAILY_SESSION_NOTE_SUCCESS,
  DELETE_DAILY_SESSION_NOTE_FAILURE,
  DELETE_DAILY_SESSION_NOTE_LOADING,
  DELETE_DAILY_SESSION_NOTE_RESET,
} = dailySessionNotes;

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const deleteDailySessionNoteReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DELETE_DAILY_SESSION_NOTE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };
    }

    case DELETE_DAILY_SESSION_NOTE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case DELETE_DAILY_SESSION_NOTE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case DELETE_DAILY_SESSION_NOTE_RESET:
      return initialState;

    default:
      return state;
  }
};
